/**
 * @param {number|string} moveId
 * @param {{ files: Array<{ key: string, name: string, content_type: string, size: number }>, inventory_category_id: number, inventory_category_slug: string, room_name: string }} payload
 */
export const startInventoryAiAnalysis = (moveId, payload) =>
    window.tenantAxios.post(`/moves/${moveId}/inventory/ai-analysis`, payload);

export const showInventoryAiAnalysis = (moveId, aiJobId, config) =>
    window.tenantAxios.get(`/moves/${moveId}/inventory/ai-analysis/${aiJobId}`, config);

export const showInventoryAiReferences = (moveId, room) =>
    window.tenantAxios.get(`/moves/${moveId}/inventory/ai-analysis/references`, {
        params: room,
    });

export const inventoryAiAnalysisFailed = (moveId) =>
    window.tenantAxios.get(`/moves/${moveId}/inventory/ai-analysis/failed`);

export const inventoryAiAnalysisActive = (moveId) =>
    window.tenantAxios.get(`/moves/${moveId}/inventory/ai-analysis/active`);

/**
 * @param {number|string} moveId
 * @param {{ ai_job_ids: number[] }} payload
 */
export const retryFailedInventoryAiAnalyses = (moveId, payload) =>
    window.tenantAxios.post(`/moves/${moveId}/inventory/ai-analysis/retry-failed`, payload);
